import React, { lazy, Suspense, useCallback, useState } from 'react'
import { useOverlay, useContainerWidth, Button, IconButton } from '@fs/zion-ui'
import { css } from '@linaria/core'
import { useTranslation } from 'react-i18next'
import { HelpAi } from '@fs/zion-icon'

const HelpChatbot = lazy(() => import('./HelpChatbot'))

const desktopButtonCss = css`
  display: flex;
  position: fixed;
  bottom: 60px; /* Distance from the bottom of the screen */
  inset-inline-end: 60px; /* Distance from the right of the scr,een */
  z-index: 2; /* Ensure it stays on top of other elements */
`
const mobileButtonCss = css`
  display: flex;
  position: fixed;
  bottom: 40px; /* Distance from the bottom of the screen */
  inset-inline-end: 40px; /* Distance from the right of the screen */
  z-index: 2; /* Ensure it stays on top of other elements */
`

function ChatbotButton() {
  const [t] = useTranslation()
  const [loadChatbot, setLoadChatbot] = useState(false)
  const atWidth = useContainerWidth()
  const isMobile = atWidth({ default: true, md: false })
  const chatbotOverlay = useOverlay()

  const handleClick = useCallback(() => {
    setLoadChatbot(true)
    chatbotOverlay.handleClick()
  }, [chatbotOverlay])

  return (
    <>
      <div className={isMobile ? mobileButtonCss : desktopButtonCss}>
        {isMobile ? (
          <IconButton
            ref={chatbotOverlay.targetRef}
            title={t('help-overlay-button.text', 'Get Help')}
            color="gray"
            emphasis="high"
            Icon={HelpAi}
            onClick={handleClick}
            size="md"
            data-testid="help-overlay-lower-left"
            linkName="LIHP-USA:help-chat-bot"
          />
        ) : (
          <Button
            ref={chatbotOverlay.targetRef}
            title={t('help-overlay-button.text', 'Get Help')}
            color="gray"
            emphasis="high"
            Icon={HelpAi}
            onClick={handleClick}
            size={atWidth({ sm: 'md', md: 'lg' })}
            data-testid="help-overlay-lower-left"
            linkName="LIHP-USA:help-chat-bot"
          >
            {t('help-overlay-button.text', 'Get Help')}
          </Button>
        )}
      </div>
      {loadChatbot && <HelpChatbot anchor={chatbotOverlay.targetRef} overlay={chatbotOverlay} />}
    </>
  )
}

export default function ChatbotLaunchButton() {
  return (
    <Suspense fallback={null}>
      <ChatbotButton />
    </Suspense>
  )
}
